import React, { useContext, useState } from 'react';
import { Flex } from '@aws-amplify/ui-react';
import { Button } from '@mui/material';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import DateOptions from '../../../layouts/DateOptions';
import { SigmaEmbed } from '../../../layouts/SigmaEmbed';
import CustomAccordion from '../../../layouts/CustomAccordion';
import { FilterSummary } from '../../../layouts/FilterSummary/FilterSummary';
import { useIdleTimer } from '../../../utils/IdleTimer';
import { FiltersContext } from '../../../components/Navigation/Routes';
import featureToggle from '../../../featureToggle.json';
import Dev from '../../dev/Dev';
import { QBR_REPORTS } from './qbrReports';
import quickFactsStyles from '../QuickFacts/QuickFacts.module.css';
import styles from './QBRs.module.css';

export const QBRs = ({ page }) => {
  const context = useContext(FiltersContext);
  const { channel, handleResetFilters, switchOn, setSwitchOn } = context;

  const environment = process.env.REACT_APP_ENVIRONMENT;
  const [selectedReportId, setSelectedReportId] = useState(QBR_REPORTS[0].id);
  const selectedReport =
    QBR_REPORTS.find((report) => report.id === selectedReportId) ??
    QBR_REPORTS[0];
  const [checked, setChecked] = useState(true);
  const [switchDisabled, setSwitchDisabled] = useState(true);

  useIdleTimer(channel);

  if (!featureToggle[environment][page]) {
    return <Dev />;
  }

  return (
    <Flex direction={'row'} height={'100%'}>
      <Flex
        direction={'column'}
        width={'100%'}
        height={'100%'}
        overflow={'hidden'}
        paddingTop={'12px'}
      >
        <Flex
          direction={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          margin={'0px 12px 0px 12px'}
        >
          <Flex direction={'row'} className={styles['qbr-tabs']}>
            {QBR_REPORTS.map((report) => (
              <Button
                key={report.id}
                onClick={() => setSelectedReportId(report.id)}
                className={`information-buttons ${
                  report.id === selectedReport.id
                    ? styles['qbr-tab-selected']
                    : ''
                }`}
              >
                {report.label}
              </Button>
            ))}
          </Flex>
          <Flex direction={'column'} alignItems={'flex-end'}>
            <Flex direction={'row'} alignItems={'center'}>
              <CustomAccordion page={page} />
              <div className={quickFactsStyles['refresh-icon-container']}>
                <Button
                  className={quickFactsStyles['refresh-button']}
                  variant="contained"
                  onClick={() => handleResetFilters(page)}
                  disableElevation
                >
                  <div className={quickFactsStyles['icon-container']}>
                    <CachedOutlinedIcon
                      className={quickFactsStyles['cached-outlined-icon']}
                    />
                  </div>
                </Button>
              </div>
            </Flex>
            <Flex paddingTop={'8px'}>
              <DateOptions
                page={page}
                checked={checked}
                setChecked={setChecked}
                switchOn={switchOn}
                setSwitchOn={setSwitchOn}
                switchDisabled={switchDisabled}
                setSwitchDisabled={setSwitchDisabled}
              />
            </Flex>
          </Flex>
        </Flex>
        <SigmaEmbed page={page} embedKey={selectedReport.submenu} />
      </Flex>
      <FilterSummary page={page} />
    </Flex>
  );
};
